import script from "./SurveyFormEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyFormEditView.vue?vue&type=script&setup=true&lang=js"

import "./SurveyFormEditView.vue?vue&type=style&index=0&id=91774f86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91774f86"]])

export default __exports__